import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import StudentForm from './StudentForm';
import StudentProgress from './StudentProgress';
import StudentGradebook from './StudentGradebook';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { Button, Tab, Tabs, Grid, DialogTitle, DialogContent, DialogActions, Dialog, Typography } from '@material-ui/core';
import DetailCalendar from '../../components/DetailCalendar';
import RelationUpdateTabs from '../../components/RelationUpdateTabs';
import StaticRelationList from '../../components/StaticRelationList';
import * as validatorActions from '../../components/validator/store/actions';
import TabPanelButtons from '../../components/TabPanelButtons';
import _ from 'lodash';
import PageHeader from 'main/components/PageHeader';
import StudentCoursesTab from './StudentCoursesTab'

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Student extends Component {
    state = {
        current_tab: 0,
        student_id: 0,
        view_type: '',
        tabValue: 0,
        companySearch: '',
        deleteDialogActive: false
    }

    constructor(props) {
        super(props);

        const student_id = this.props.match.params.student_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            student_id: student_id,
            view_type: view_type,
        }

        this.props.updateStudentLoaded(false);
        this.props.getStudentData(student_id);
        this.props.getStudentProgressReport(student_id);

        const validationList = [
            {
                field_name: 'FirstName', functionName: ['checkRequiredFilled']
            },
            {
                field_name: 'LastName', functionName: ['checkRequiredFilled']
            },
            {
                field_name: 'Email', functionName: ['checkEmailUnique', 'checkEmailValid'], id: student_id, component: 'student'
            },
            {
                field_name: 'Password', functionName: ['checkFieldLength'], chars: 4,
            },
            {
                field_name: 'PasswordConfirm', functionName: ['checkFieldLength'], chars: 4,
            },
        ]

        this.props.startValidator(validationList)
    }

    handleChangeTab = (event, value) => {
        this.setState({
            current_tab: value
        });
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleSubmit = () => {
        switch (this.state.view_type) {
            case ("create"):
            {   
                this.props.saveStudent(this.props.currentStudent, this.props.currentCompanies, this.props.auth.user.data.auth_id);

                this.props.history.push('/student/list');
                break;
            }

            case ("edit"):
            {
                this.props.saveStudent(this.props.currentStudent, this.props.currentCompanies, this.props.auth.user.data.auth_id);

                this.props.history.push('/student/list');
                break;
            }

            default:
            {

            }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
            {
                this.props.deleteStudent(this.props.currentStudent.student_id);
                this.props.history.push('/student/list');
                break;
            }

            default:
            {

            }
        }
    }

    handleCompanySearchChange = (e) => {
        this.setState({
            companySearch: e.target.value
        })
    }

    deactivateStudentAuth = () => {
        this.props.deactivateStudentAuth(this.props.currentStudent.related_auth_id, this.props.currentStudent.student_id);
        this.props.history.push('/student/list');
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, currentStudent, isStudentLoaded, events, dayEvents, theme } = this.props;

        switch (current_tab) {
            case (0):
            {
                return (
                    <StudentForm
                        view_type={view_type}
                    />
                )
            }
            case (1):
            {
                return (
                    <DetailCalendar
                        object_id={currentStudent.student_id}
                        events={events}
                        dayEvents={dayEvents}
                        getSchedule={this.props.getSchedule}
                        getDayEvents={this.props.getDayEvents}
                        baseComponent={'student'}
                    />
                )
            }
            case (2):
            {
                return (
                    <StudentProgress
                        progress={this.props.studentProgressReport}
                        student={this.props.currentStudent}
                        history={this.props.history}
                        auth={this.props.auth}
                    />
                )
            }
            case (3):
            {
                return (
                    <StudentCoursesTab
                        student={this.props.currentStudent}
                        history={this.props.history}
                        auth={this.props.auth}
                        progress={this.props.studentProgressReport}
                    />
                )
            }
            case (4):
            {
                return (
                    <StudentGradebook
                        progress={this.props.studentProgressReport}
                        student={this.props.currentStudent}
                        history={this.props.history}
                        auth={this.props.auth}
                    />
                )
            }
            default:
            {
                return <React.Fragment>Error: No tab found.</React.Fragment>
            }
        }
    }

    getDeleteDialog = (active, student) => {

        const role_info = (prop) => {
            if (prop) {
                return (
                    <div>
                        <Typography>{student.FirstName + ' ' + student.LastName} has the following roles: </Typography>
                        {this.props.roles.map((role, i) => {
                            return (
                                <div key={i}> <b>{i + 1}</b>: {role.RoleName} </div>
                            )
                        })}
                    </div>
                )
            }
        }

        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Delete {student.FirstName + ' ' + student.LastName}?</DialogTitle>
                <DialogContent>
                    {role_info(this.props.roles.length > 1)}
                    <div>Deactivating User will not delete roles or data associated with the user, but it will hide them.</div>
                    <div>Deleting Student will remove all relationships with courses, and companies.</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.deactivateStudentAuth()} color="primary">
                        Deactivate User
                    </Button>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Delete Student
                    </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    render() {
        const { classes, currentStudent, isStudentLoaded } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentStudent)

        if (!isStudentLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isStudentLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name = {currentStudent.FirstName + " " + currentStudent.LastName}
                        component_type = {"student"}
                        view_type      = {view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Schedule"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Progress"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Current Courses"
                                    hidden={this.props.auth.user.role != 'Dev' || this.props.auth.user.role != 'Admin' || this.props.auth.user.role != 'Company'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Gradebook"
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name = {"student"}
                                view_type      = {view_type}
                                button_list    = {[
                                    {
                                        display:  "Save",
                                        type:     "update",
                                        onClick:  this.handleSubmit,
                                        disabled: this.disableSave(),
                                    },
                                    {
                                        type:    "delete",
                                        onClick: this.handleDeleteDialogOpen,
                                    },
                                    {
                                        type:    "back",
                                        onClick: this.props.history.goBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {delete_dialog}
                            {page_content}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudent:          Actions.getStudent,
        getStudentData:      Actions.getStudentData,
        updateStudentLoaded: Actions.updateStudentLoaded,
        saveStudent:         Actions.saveStudent,
        deleteStudent:       Actions.deleteStudent,
        getStudentList:      Actions.getStudentList,
        updateStudentForm:   Actions.updateStudentForm,
        getSchedule:         Actions.getStudentSchedule,
        getDayEvents:        Actions.getDayEvents,
        toggleCompany:       Actions.toggleCompany,
        getStudentProgressReport:  Actions.getStudentProgressReport,
        deactivateStudentAuth: Actions.deactivateStudentAuth,
        startValidator:      validatorActions.startValidator
    }, dispatch);
}

function mapStateToProps({ studentApp, validator, auth }) {
    return {
        currentStudent:   studentApp.students.currentStudent,
        isStudentLoaded:  studentApp.students.isStudentLoaded,
        events:           studentApp.students.events,
        dayEvents:        studentApp.students.dayEvents,
        allCompanies:     studentApp.students.allCompanies,
        currentCompanies: studentApp.students.currentCompanies,
        roles:            studentApp.students.roles,
        studentProgressReport:  studentApp.students.studentProgressReport,
        validator:        validator.list,
        auth:             auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Student)));



// WEBPACK FOOTER //
// src/main/content/student/Student.js